import { render } from "./loginAuth.vue?vue&type=template&id=16e58ca0&scoped=true"
import script from "./loginAuth.vue?vue&type=script&lang=js"
export * from "./loginAuth.vue?vue&type=script&lang=js"

import "./loginAuth.vue?vue&type=style&index=0&id=16e58ca0&lang=scss&scoped=true"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e58ca0"]])

export default __exports__